import { PagoDetalle } from "./pago_detalle";
import { PagoGrupo } from "./pago-grupo";
import { AsientoContable } from "./asiento-contable";

export class Pago{
    public constructor(
        public id: String = "",
        public saldo: number = 0,
        public recibido: number = 0,
        public cambio: number = 0,
        public fecha_pago: any = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public observacion: string = "",
        public compra_id: String = "",
        //public caja_id: String = "",

        public usuario_id:String = null,
        public detalle: Array<PagoDetalle> = [],
        public grupo: Array<PagoGrupo> = [],

        public asientosContables: Array<AsientoContable> = [],
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/pago.ts